// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  line-height: 1.6;
  color: #333;
  margin: 0;
  padding: 0;
}
/* Loading styles */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  flex-direction: column;
}
.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/* Homepage layout */
.homepage {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
/* Header */
.homepage-header {
  background: #fff;
  border-bottom: 1px solid #eee;
  padding: 1rem 2rem;
  position: sticky;
  top: 0;
}
.main-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}
.logo h1 {
  color: #007bff;
  font-size: 1.5rem;
}
.nav-links {
  display: flex;
  gap: 1rem;
}
.nav-links button {
  background: none;
  border: none;
  color: #333;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 4px;
}
.nav-links button:hover {
  background-color: #f8f9fa;
}
.login-section button {
  background: #007bff;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
}
/* Main content */
.homepage-main {
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.full-width-container{
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}

/* Hero section */
.hero-section {
  text-align: center;
  padding: 4rem 0;
}
.hero-section h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}
.hero-section p {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 2rem;
}
.cta-primary {
  background: #007bff;
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  border-radius: 4px;
  cursor: pointer;
}
.cta-primary:hover {
  background: #0056b3;
}
/* Featured apps */
.featured-apps {
  margin-top: 4rem;
}
.featured-apps h2 {
  text-align: center;
  margin-bottom: 2rem;
}
.apps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}
.app-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
}
.app-card img {
  width: 64px;
  height: 64px;
  margin-bottom: 1rem;
}
.app-card h3 {
  margin-bottom: 0.5rem;
}
.app-card p {
  color: #666;
  margin-bottom: 1rem;
}
.app-card-cta {
  background: #28a745;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
}
.no-apps {
  text-align: center;
  padding: 2rem;
  color: #666;
}
.no-apps button {
  background: #007bff;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 1rem;
}
/* Debug info */
.debug-info {
  background: #f8f9fa;
  padding: 1rem;
  margin: 2rem 0;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}
.debug-info ul {
  list-style: none;
}
.debug-info li {
  margin: 0.5rem 0;
}
/* Footer */
.homepage-footer {
  background: #f8f9fa;
  padding: 2rem;
  margin-top: auto;
  border-top: 1px solid #eee;
}
.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}
.footer-links {
  margin-bottom: 1rem;
}
.footer-links a {
  color: #007bff;
  text-decoration: none;
  margin: 0 1rem;
}
/* Single-SPA application container - positioned within layout */
/* #single-spa-application-container {
  width: 100%;
  min-height: 500px;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
} */
/* SmartSearch specific container styling */
#smart-search-container,
#smartsearch-container {
  width: 100%;
  min-height: 500px;
  position: relative;
}
#smart-search-container > div:first-child {
  /* Add your styles here */
  max-width: 94vw
}
#smart-search-container > div > sdf-layout-justify-edge > sdfx-box-stack:nth-child(2) > div:first-child {
  height: calc(48vh);
}
/* Shared layout root - NOT fixed positioned */
#shared-layout-root {
  width: 100%;
  min-height: 100vh;
  position: relative;
}
/* Responsive */
@media (max-width: 768px) {
  .main-nav {
    flex-direction: column;
    gap: 1rem;
  }
  
  .hero-section h1 {
    font-size: 2rem;
  }
  
  .apps-grid {
    grid-template-columns: 1fr;
  }
  
  /* #single-spa-application-container {
    padding: 1rem;
    min-height: 300px;
  } */
  }

  #smart-search-wrapper {
  /* Ensure it doesn't break out of container */
  contain: layout style paint;
  transform: translateZ(0); /* Create stacking context */
}
#smart-search-wrapper * {
  /* Prevent any child elements from going full screen */
  max-width: 100% !important;
  box-sizing: border-box;
}
/* Target common full-screen patterns that might cause issues */
#smart-search-wrapper [style*="position: fixed"],
#smart-search-wrapper [style*="position: absolute"] {
  position: relative !important;
}
#smart-search-wrapper [style*="width: 100vw"],
#smart-search-wrapper [style*="height: 100vh"] {
  width: 100% !important;
  height: auto !important;
  max-height: 70vh !important;
}
/* Stable sizing to prevent reflow */
#smart-search-wrapper {
  min-height: 500px !important;
  max-height: 80vh !important;
  overflow-y: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sEAAsE;EACtE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;AACA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA,WAAW;AACX;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;AACR;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;AACA,iBAAiB;AACjB;EACE,OAAO;EACP,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA,eAAe;AACf;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA,WAAW;AACX;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;AACA,gEAAgE;AAChE;;;;;;;GAOG;AACH,2CAA2C;AAC3C;;EAEE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB;AACF;AACA;EACE,kBAAkB;AACpB;AACA,8CAA8C;AAC9C;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;KAGG;EACH;;EAEA;EACA,6CAA6C;EAC7C,2BAA2B;EAC3B,wBAAwB,EAAE,4BAA4B;AACxD;AACA;EACE,sDAAsD;EACtD,0BAA0B;EAC1B,sBAAsB;AACxB;AACA,+DAA+D;AAC/D;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA,oCAAoC;AACpC;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;AAC7B","sourcesContent":["body {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  line-height: 1.6;\n  color: #333;\n  margin: 0;\n  padding: 0;\n}\n/* Loading styles */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  flex-direction: column;\n}\n.spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n/* Homepage layout */\n.homepage {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n/* Header */\n.homepage-header {\n  background: #fff;\n  border-bottom: 1px solid #eee;\n  padding: 1rem 2rem;\n  position: sticky;\n  top: 0;\n}\n.main-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n.logo h1 {\n  color: #007bff;\n  font-size: 1.5rem;\n}\n.nav-links {\n  display: flex;\n  gap: 1rem;\n}\n.nav-links button {\n  background: none;\n  border: none;\n  color: #333;\n  cursor: pointer;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n}\n.nav-links button:hover {\n  background-color: #f8f9fa;\n}\n.login-section button {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n}\n/* Main content */\n.homepage-main {\n  flex: 1;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.full-width-container{\n  width: 100vw;\n  position: relative;\n  left: 50%;\n  right: 50%;\n  margin-left: -50vw;\n  margin-right: -50vw;\n}\n\n/* Hero section */\n.hero-section {\n  text-align: center;\n  padding: 4rem 0;\n}\n.hero-section h1 {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n.hero-section p {\n  font-size: 1.2rem;\n  color: #666;\n  margin-bottom: 2rem;\n}\n.cta-primary {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  font-size: 1.1rem;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.cta-primary:hover {\n  background: #0056b3;\n}\n/* Featured apps */\n.featured-apps {\n  margin-top: 4rem;\n}\n.featured-apps h2 {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n.apps-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n.app-card {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 1.5rem;\n  text-align: center;\n}\n.app-card img {\n  width: 64px;\n  height: 64px;\n  margin-bottom: 1rem;\n}\n.app-card h3 {\n  margin-bottom: 0.5rem;\n}\n.app-card p {\n  color: #666;\n  margin-bottom: 1rem;\n}\n.app-card-cta {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.no-apps {\n  text-align: center;\n  padding: 2rem;\n  color: #666;\n}\n.no-apps button {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 1rem;\n}\n/* Debug info */\n.debug-info {\n  background: #f8f9fa;\n  padding: 1rem;\n  margin: 2rem 0;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n}\n.debug-info ul {\n  list-style: none;\n}\n.debug-info li {\n  margin: 0.5rem 0;\n}\n/* Footer */\n.homepage-footer {\n  background: #f8f9fa;\n  padding: 2rem;\n  margin-top: auto;\n  border-top: 1px solid #eee;\n}\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  text-align: center;\n}\n.footer-links {\n  margin-bottom: 1rem;\n}\n.footer-links a {\n  color: #007bff;\n  text-decoration: none;\n  margin: 0 1rem;\n}\n/* Single-SPA application container - positioned within layout */\n/* #single-spa-application-container {\n  width: 100%;\n  min-height: 500px;\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  position: relative;\n} */\n/* SmartSearch specific container styling */\n#smart-search-container,\n#smartsearch-container {\n  width: 100%;\n  min-height: 500px;\n  position: relative;\n}\n#smart-search-container > div:first-child {\n  /* Add your styles here */\n  max-width: 94vw\n}\n#smart-search-container > div > sdf-layout-justify-edge > sdfx-box-stack:nth-child(2) > div:first-child {\n  height: calc(48vh);\n}\n/* Shared layout root - NOT fixed positioned */\n#shared-layout-root {\n  width: 100%;\n  min-height: 100vh;\n  position: relative;\n}\n/* Responsive */\n@media (max-width: 768px) {\n  .main-nav {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .hero-section h1 {\n    font-size: 2rem;\n  }\n  \n  .apps-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  /* #single-spa-application-container {\n    padding: 1rem;\n    min-height: 300px;\n  } */\n  }\n\n  #smart-search-wrapper {\n  /* Ensure it doesn't break out of container */\n  contain: layout style paint;\n  transform: translateZ(0); /* Create stacking context */\n}\n#smart-search-wrapper * {\n  /* Prevent any child elements from going full screen */\n  max-width: 100% !important;\n  box-sizing: border-box;\n}\n/* Target common full-screen patterns that might cause issues */\n#smart-search-wrapper [style*=\"position: fixed\"],\n#smart-search-wrapper [style*=\"position: absolute\"] {\n  position: relative !important;\n}\n#smart-search-wrapper [style*=\"width: 100vw\"],\n#smart-search-wrapper [style*=\"height: 100vh\"] {\n  width: 100% !important;\n  height: auto !important;\n  max-height: 70vh !important;\n}\n/* Stable sizing to prevent reflow */\n#smart-search-wrapper {\n  min-height: 500px !important;\n  max-height: 80vh !important;\n  overflow-y: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
